import { render, staticRenderFns } from "./Scheme7.vue?vue&type=template&id=4e97a9b8&scoped=true"
import script from "./Scheme7.vue?vue&type=script&lang=js"
export * from "./Scheme7.vue?vue&type=script&lang=js"
import style0 from "./Scheme7.vue?vue&type=style&index=0&id=4e97a9b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e97a9b8",
  null
  
)

export default component.exports